export const getMessagesData = state => state.messages.data;
export const getMessageData = state => state.messages.message;
export const getUpPaginationData = state => state.messages.upPagination;
export const getDownPaginationData = state => state.messages.downPagination;
export const messagesIsFetching = state => state.messages.loading.all;
export const messageIsFetching = state => state.messages.loading.message;